const hasValidMandatoryIngredients = (item) => {
    return Boolean(item?.mandatoryIngredients?.some((group) => {
        if (!group) {
            return false;
        }
        const hasName = typeof group.name === 'string' && group.name.trim().length > 0;
        const hasIngredients = Array.isArray(group.ingredients) && group.ingredients.length > 0;
        return hasName && hasIngredients;
    }));
};
const hasConfigurableExtras = (item) => {
    // Das Konfig-Modal zeigt Extras, sobald welche vorhanden sind – unabhängig vom
    // (oft nicht gesetzten) customizable-Flag. Auch die verschachtelte Struktur
    // ingredients.extras berücksichtigen.
    const direct = Array.isArray(item?.extraIngredients) && item.extraIngredients.length > 0;
    const nested = Array.isArray(item?.ingredients?.extras) &&
        item.ingredients.extras.length > 0;
    return Boolean(direct || nested);
};
const hasRemovableIngredients = (item) => {
    // Das Modal zeigt "Zutaten entfernen", wenn removableIngredients ODER
    // ingredients.base vorhanden sind.
    const explicit = Array.isArray(item?.removableIngredients) &&
        item.removableIngredients.length > 0;
    const base = Array.isArray(item?.ingredients?.base) &&
        item.ingredients.base.length > 0;
    return Boolean(explicit || base);
};
const hasSizeOptions = (item) => {
    return Boolean(item?.hasSizes && Array.isArray(item.sizes) && item.sizes.length > 0);
};
/**
 * Determine whether a product requires the configuration modal before it can be added to the cart.
 * This covers extras, removable ingredients, multiple sizes and mandatory ingredient groups.
 */
export const needsProductConfiguration = (item) => {
    if (!item) {
        return false;
    }
    return (hasConfigurableExtras(item) ||
        hasSizeOptions(item) ||
        hasValidMandatoryIngredients(item) ||
        hasRemovableIngredients(item));
};
export const productConfigurationHelpers = {
    needsProductConfiguration
};
